// Libs
import React from 'react';
// Components
import { Title } from 'components';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';
// Styles
import styles from './SimpleBar.module.css';

const BAR_COLORS = [
	'#8884d8', '#82ca9d', '#ffc658', '#ff7c7c', '#a4de6c',
	'#d0ed57', '#88d8b0', '#ff8042', '#0088FE', '#00C49F',
];

const SimpleBar = ({ data, config = {} }) => {
	const {
		width = 500,
		height = 300,
		xDataKey = config.indexedBy || 'name',
	} = config;

	const barKeys = data.length > 0
		? Object.keys(data[0]).filter(k => k !== xDataKey)
		: [];

	return (
		<div className={styles.simpleBarContainer} style={{ width, height }}>
			<ResponsiveContainer width='100%' height='100%'>
				<BarChart
					width={width}
					height={height}
					data={data}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5,
					}}
				>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis dataKey={xDataKey} />
					<YAxis />
					<Tooltip />
					<Legend />
					{barKeys.map((key, index) => (
						<Bar key={key} dataKey={key} fill={BAR_COLORS[index % BAR_COLORS.length]} />
					))}
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default SimpleBar;
